import { render, staticRenderFns } from "./CreateNewModal.vue?vue&type=template&id=2e797c8f&scoped=true&lang=pug"
import script from "./CreateNewModal.vue?vue&type=script&lang=js"
export * from "./CreateNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e797c8f",
  null
  
)

export default component.exports